"use strict";

var _classCallCheck = require("/root/aiga-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/aiga-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TypedSerializer =
/*#__PURE__*/
function () {
  function TypedSerializer() {
    _classCallCheck(this, TypedSerializer);
  }

  _createClass(TypedSerializer, null, [{
    key: "serialize",

    /**
     * Use this method to remove underscore "_" from prop when serializing Typed Object
     * @param obj
     * @returns {{}&U}
     */
    value: function serialize(obj) {
      var serialized = Object.assign({}, obj);
      var props = Object.getOwnPropertyNames(serialized);
      props.filter(function (prop) {
        return prop.startsWith('_');
      }).map(function (prop) {
        var newName = prop.substring(1, prop.length);
        Object.defineProperty(serialized, newName, Object.getOwnPropertyDescriptor(serialized, prop));
        delete serialized[prop];
      });
      return serialized;
    }
  }]);

  return TypedSerializer;
}();

exports.TypedSerializer = TypedSerializer;